import EventBus from '../../utils/EventBus';
import {stringFilter} from '../../filters';
import scrollToTarget from '../../utils/ScrollToTarget';
import Responsive from '../../utils/Responsive';

export default {
    props: {
        config: {},
        enabled: {
            required: false,
            type: Boolean,
            default: true
        },
        fixScroll: {
            required: false,
            type: Boolean,
            default: false
        },
        linkedBreakpoint: {
            required: false,
            type: String,
            default: null
        }
    },
    data() {
        return {
            activeIcon: this.config.activeIcon || '#minus',
            inactiveIcon: this.config.inactiveIcon || '#plus',
            activeLabel: this.config.activeLabel || 'Verberg',
            inactiveLabel: this.config.inactiveLabel || 'Toon',
            items: [],
            isEnabled: this.enabled
        }
    },
    computed: {
        classList() {
            return {
                'is-collapsible': this.isEnabled
            }
        },
    },
    mounted() {
        this.$emit('ready', this);

        EventBus.$on('Responsive:onResize', () => {
            this.checkBreakpoint();
        });

        // Do breakpoint calculation on init too
        this.checkBreakpoint();
    },
    methods: {
        checkBreakpoint() {
            if (this.linkedBreakpoint) {
                if (Responsive.respondMin('!' + this.linkedBreakpoint)) {
                    // Not in breakpoint, disable
                    this.isEnabled = false;
                } else {
                    // In breakpoint, enable
                    this.isEnabled = true;
                }
            } else {
                this.isEnabled = this.enabled;
            }
        },
        toggle(index, $event) {
            const expanded = this.items[index];
            const eventName = expanded ? 'Collapse' : 'Expand';

            const newItems = this.items.slice(0);
            newItems[index] = !expanded;
            this.items = newItems;

            if (this.fixScroll === true) {
                scrollToTarget(this.$el, { focus: false });
            }

            EventBus.$emit(`Collapsible:on${eventName}`, $event, this.config.eventData);
        },
        isActive(index) {
            return this.items[index] === true;
        },

        /**
         * Returns true/false (String) if current index is active,
         * or false (bool) if component is not enabled at all
         * used to remove aria attribute.
         *
         * @param index
         * @returns {*}
         */
        isExpanded(index) {
            if (this.isEnabled === false) {
                return false;
            }

            return stringFilter.filters.booleanString(this.isActive(index));
        },

        /**
         * Returns true/false (String) if current index is inactive,
         * or false (bool) if component is not enabled at all
         * used to remove aria attribute.
         *
         * @param index
         * @returns {*}
         */
        isNotExpanded(index) {
            if (this.isEnabled === false) {
                return false;
            }

            return stringFilter.filters.booleanString(!this.isActive(index));
        },
        btnLabel(index) {
            return this.isActive(index) ? this.config.activeLabel : this.config.inactiveLabel;
        },
        getIconSource(index) {
            return this.isActive(index) ? this.activeIcon : this.inactiveIcon;
        }
    },
    mixins: [
        stringFilter
    ]
}
